import { useQuery, useMutation } from 'react-query'
import axios from 'axios'
import { serializeQuery } from './utils'

const ENDPOINT = 'api/point'
const QUERY_KEY = 'point'

export const useGetPointDetails = (query = {}, config = {}) =>
  useQuery(
    [QUERY_KEY, 'all', query],
    async () => (await axios.get(serializeQuery(`${ENDPOINT}`, query))).data,
    config
  )

export const useGetNexenPoints = (query = {}, config = {}) =>
  useQuery(
    [QUERY_KEY, 'nex', query],
    async () => (await axios.get(serializeQuery(`${ENDPOINT}/nex`, query))).data,
    config
  )

export const useGetNexenTripPoints = (query = {}, config = {}) =>
  useQuery(
    [QUERY_KEY, 'nex-trip', query],
    async () => (await axios.get(serializeQuery(`${ENDPOINT}/nex-trip`, query))).data,
    config
  )

export const useGetTlpPoints = (query = {}, config = {}) =>
  useQuery(
    [QUERY_KEY, 'tlp', query],
    async () => (await axios.get(serializeQuery(`${ENDPOINT}/tlp`, query))).data,
    config
  )

export const useGetTlpOrderHistory = (query = {}, config = {}) =>
  useQuery(
    [QUERY_KEY, 'tlp-order-history', query],
    async () => (await axios.get(serializeQuery(`${ENDPOINT}/tlp-order-history`, query))).data,
    config
  )

export const useGetTripPoints = (query = {}, config = {}) =>
  useQuery(
    [QUERY_KEY, 'trip', query],
    async () => (await axios.get(serializeQuery(`${ENDPOINT}/trip`, query))).data,
    config
  )

export const useGetTripOrderHistory = (query = {}, config = {}) =>
  useQuery(
    [QUERY_KEY, 'trip-order-history', query],
    async () => (await axios.get(serializeQuery(`${ENDPOINT}/trip-order-history`, query))).data,
    config
  )

export const useGetSalesIds = (query = {}, config = {}) =>
  useQuery(
    [QUERY_KEY, 'sales', query],
    async () => (await axios.get(`${serializeQuery(`${ENDPOINT}/sales`, query)}`)).data,
    config
  )

export const useGetTlpRedeem = (query = {}, config = {}) =>
  useQuery(
    [QUERY_KEY, 'sales', query],
    async () => (await axios.get(`${serializeQuery(`${ENDPOINT}/tlp-redeem`, query)}`)).data,
    config
  )

export const useExportTlpPoint = (config = {}) =>
  useMutation(
    (query) =>
      axios.get(`${serializeQuery(`${ENDPOINT}/export-tlp-point`, query)}`, {
        responseType: 'blob',
      }),
    config
  )

export const useExportTripPoint = (config = {}) =>
  useMutation(
    (query) =>
      axios.get(`${serializeQuery(`${ENDPOINT}/export-trip-point`, query)}`, {
        responseType: 'blob',
      }),
    config
  )

export const useExportNexPoint = (config = {}) =>
  useMutation(
    (query) =>
      axios.get(`${serializeQuery(`${ENDPOINT}/export-nex-point`, query)}`, {
        responseType: 'blob',
      }),
    config
  )

export const useExportNexTripPoint = (config = {}) =>
  useMutation(
    (query) =>
      axios.get(`${serializeQuery(`${ENDPOINT}/export-nex-trip-point`, query)}`, {
        responseType: 'blob',
      }),
    config
  )

export const useGetTyrehubPoints = (query = {}, config = {}) =>
  useQuery(
    [QUERY_KEY, 'tyrehub', query],
    async () => (await axios.get(serializeQuery(`${ENDPOINT}/tyrehub-points`, query))).data,
    config
  )

export const useGetTyrehubPoint = (query = {}, config = {}) =>
  useQuery(
    [QUERY_KEY, 'tyrehub-detail', query],
    async () => (await axios.get(serializeQuery(`${ENDPOINT}/tyrehub-point`, query))).data,
    config
  )

export const useExportTyrehubPoint = (config = {}) =>
  useMutation(
    (query) =>
      axios.get(`${serializeQuery(`${ENDPOINT}/export-tyrehub-point`, query)}`, {
        responseType: 'blob',
      }),
    config
  )

export const useGetBatteryIncentivePoints = (query = {}, config = {}) =>
  useQuery(
    [QUERY_KEY, 'battery-incentive', query],
    async () =>
      (await axios.get(serializeQuery(`${ENDPOINT}/battery-incentive-points`, query))).data,
    config
  )

export const useGetBatteryIncentivePoint = (query = {}, config = {}) =>
  useQuery(
    [QUERY_KEY, 'battery-incentive-detail', query],
    async () =>
      (await axios.get(serializeQuery(`${ENDPOINT}/battery-incentive-point`, query))).data,
    config
  )

export const useExportBatteryIncentivePoint = (config = {}) =>
  useMutation(
    (query) =>
      axios.get(`${serializeQuery(`${ENDPOINT}/export-battery-incentive-point`, query)}`, {
        responseType: 'blob',
      }),
    config
  )

export const useGetMobilNorthChinaTripPoints = (query = {}, config = {}) =>
  useQuery(
    [QUERY_KEY, 'mobil-north-china-trip', query],
    async () =>
      (await axios.get(serializeQuery(`${ENDPOINT}/mobil-north-china-trip-points`, query))).data,
    config
  )

export const useGetMobilNorthChinaTripPoint = (query = {}, config = {}) =>
  useQuery(
    [QUERY_KEY, 'mobil-north-china-trip-detail', query],
    async () =>
      (await axios.get(serializeQuery(`${ENDPOINT}/mobil-north-china-trip-point`, query))).data,
    config
  )

export const useExportMobilNorthChinaTripPoint = (config = {}) =>
  useMutation(
    (query) =>
      axios.get(`${serializeQuery(`${ENDPOINT}/export-mobil-north-china-trip-point`, query)}`, {
        responseType: 'blob',
      }),
    config
  )

export const useGetFiestaPoints = (query = {}, config = {}) =>
  useQuery(
    [QUERY_KEY, 'fiesta', query],
    async () => (await axios.get(serializeQuery(`${ENDPOINT}/fiesta-points`, query))).data,
    config
  )

export const useExportFiestaPoint = (config = {}) =>
  useMutation(
    (query) =>
      axios.get(`${serializeQuery(`${ENDPOINT}/export-fiesta-point`, query)}`, {
        responseType: 'blob',
      }),
    config
  )

export const useExportFiestaTicket = (config = {}) =>
  useMutation(
    (query) =>
      axios.get(`${serializeQuery(`${ENDPOINT}/export-fiesta-ticket`, query)}`, {
        responseType: 'blob',
      }),
    config
  )
